class CodexThemeSignatureRuntime {
  constructor(signatureData) {
    this.signatureData = signatureData;
  }

  mount() {
    document.documentElement.setAttribute("data-codex-code-runtime", this.signatureData.signature);
    document.documentElement.setAttribute("data-codex-code-runtime-family", this.signatureData.family);
    window.__CODEX_THEME_SIGNATURE__ = this.signatureData;
  }
}

const codexThemeSignatureRuntime = new CodexThemeSignatureRuntime({"signature":"t29ppr-0c","family":"gci"});

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => codexThemeSignatureRuntime.mount(), { once: true });
} else {
  codexThemeSignatureRuntime.mount();
}
